import * as React from 'react';
import {Col, Row} from 'react-bootstrap';
import './style.scss';

export class RCPStrengths extends React.Component<any, any> {
  public render() {
    return (
      <Row>
        <Col md={4} className={'homepage-block'}>
          <Row>
            <Col className={'block-image'} md={12}>
              <img src={require('./img/expertise-metier.jpg')} alt=""/>
            </Col>

            <Col md={12}>
              <h3 className={'block-title'}>
                Expertise métier
              </h3>
            </Col>
            <Col md={12}>
              <ul>
                <li>20 ans d’expérience et de savoir-faire</li>
                <li>Des souscripteurs spécialisés à votre service</li>
                <li>Tarifs compétitifs</li>
              </ul>
            </Col>
          </Row>
        </Col>
        <Col md={4} className={'homepage-block'}>
          <Row>
            <Col className={'block-image'} md={12}>
              <img src={require('./img/souscription-digital.jpg')} alt=""/>
            </Col>

            <Col md={12}>
              <h3 className={'block-title'}>
                Souscription digitalisée
              </h3>
            </Col>
            <Col md={12}>
              <ul>
                <li>Solution 100% en ligne, du devis au paiement</li>
                <li>Aucun document requis</li>
                <li>Attestation d’assurance immédiatement disponible</li>
              </ul>
            </Col>
          </Row>
        </Col>
        <Col md={4} className={'homepage-block'}>
          <Row>
            <Col className={'block-image'} md={12}>
              <img src={require('./img/gestion-simplifiee.jpg')} alt=""/>
            </Col>

            <Col md={12}>
              <h3 className={'block-title'}>
                Gestion simplifiée
              </h3>
            </Col>
            <Col md={12}>
              <ul>
                <li>Espace personnel sécurisé</li>
                <li>Accès direct à l’ensemble de vos documents</li>
                <li>
                  Transmission de vos données à l’ORIAS aux fins de renouvellement de votre
                  inscription au Registre Unique
                </li>
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/RCPStrengths/index.tsx